import { render, staticRenderFns } from "./TopMenuLogout.vue?vue&type=template&id=446758ef"
import script from "./TopMenuLogout.vue?vue&type=script&lang=ts"
export * from "./TopMenuLogout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports